import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';


@Injectable()
export class ClinicalTrialService {
    baseUrl = '/clinicalTrialMatch';
  constructor(
    private _http: HttpInterceptorService,
  ) {
  }

  public getAll(revisionId: any) {
    return this._http.get(this.baseUrl, { context: revisionId});
  }
 }
